import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

export interface ConsentManagementTranslations {
  privacyPolicyUrl: string;
}

export const CONSENT_MANAGEMENT_TRANSLATIONS = new InjectionToken<Observable<ConsentManagementTranslations>>(
  'shared.util-core.ConsentManagementTranslations'
);

export const FT_HDMS_DIDOMI_COOKIE_CONSENT = 'ldt_hdms_didomi_cookieconsent';
